import { render, staticRenderFns } from "./ProdukEceran.vue?vue&type=template&id=d0a01bca&scoped=true"
import script from "./ProdukEceran.vue?vue&type=script&lang=js"
export * from "./ProdukEceran.vue?vue&type=script&lang=js"
import style0 from "./ProdukEceran.vue?vue&type=style&index=0&id=d0a01bca&prod&lang=scss&scoped=true"
import style1 from "./ProdukEceran.vue?vue&type=style&index=1&id=d0a01bca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a01bca",
  null
  
)

export default component.exports